import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../../admin.service';


@Component({
    selector: 'app-competition-info',
    templateUrl: './competition-info.component.html',
    styleUrls: ['./competition-info.component.css']
  })


export class CompetitionInfo implements OnInit {
    competitionId = "";
    status = "";
    competitionDetails : any;
    approvedCompetition = 0;
    rejectedCompetition = 0;
    pendingCompetition = 0;
    scheduleCompetition = 0;
    previewPage = 0;
    showEditField = false;
    resultDeclared;
    hasCompetitionZoneAccess: boolean = false;
    hasPostHubAccess: boolean = false;

    constructor(private activatedRoute: ActivatedRoute, private admminService : AdminService){}
    ngOnInit(): void {
        const adminFeatureList = sessionStorage.getItem('adminFeatureList');
        if (adminFeatureList) {
          const features = JSON.parse(adminFeatureList);
          this.hasCompetitionZoneAccess = features.includes('competitions');
          this.hasPostHubAccess = features.includes('posts');
        }
        this.competitionId = this.activatedRoute.snapshot.params.competitionUUID;
        this.status = this.activatedRoute.snapshot.params.status;
        this.resultDeclared = this.activatedRoute.snapshot.params.result;
        this.getCompetitionDetails();
    }
    getCompetitionDetails(){
        this.admminService.getCompetitionDetails(this.competitionId).subscribe(
            (res) => {
                this.competitionDetails = res.body.competition;

                this.competitionDetails?.submission_status_count.forEach(item => {
                    switch (item.status) {
                      case 'REJECTED':
                        this.rejectedCompetition = item.count;
                        break;
                      case 'PENDING':
                        this.pendingCompetition = item.count;
                        break;
                      case 'APPROVED':
                        this.approvedCompetition = item.count;
                        break;
                      case 'SHORTLISTED':
                        this.scheduleCompetition = item.count;
                        break;
                      default:
                        break;
                    }
                  });    
         
            },
            (error)=> {
               console.log(error);
            }
            )
    }
    onClickPreview(ind){
        this.previewPage = ind;
    }
}

